import React from 'react';
import { FileText, User, CheckSquare, CreditCard } from 'lucide-react';
import { useLanguage } from '../../../contexts/LanguageContext';

type Props = {
  currentStep: string;
  userType: 'guide' | 'organizer';
};

export const WizardProgress = ({ currentStep, userType }: Props) => {
  const { translations } = useLanguage();

  const steps = [
    { step: 'terms', icon: FileText, label: translations?.wizardProgress?.steps?.terms || 'Terms' },
    { step: 'info', icon: User, label: translations?.wizardProgress?.steps?.info || 'Information' },
    ...(userType === 'organizer'
      ? [{ step: 'bank', icon: CreditCard, label: translations?.wizardProgress?.steps?.bank || 'Bank Info' }]
      : []),
    { step: 'contract', icon: CheckSquare, label: translations?.wizardProgress?.steps?.contract || 'Contract' }
  ];

  return (
    <div className="mb-8">
      <div className="flex justify-between">
        {steps.map(({ step, icon: Icon, label }) => (
          <div
            key={step}
            className={`flex flex-col items-center ${
              step === currentStep ? 'text-primary-500' : 'text-gray-400'
            }`}
          >
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center ${
                step === currentStep ? 'bg-primary-50' : 'bg-gray-100'
              }`}
            >
              <Icon size={20} />
            </div>
            <span className="mt-2 text-sm">{label}</span>
          </div>
        ))}
      </div>
      <div className="relative mt-4">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-200" />
        </div>
        <div className="relative flex justify-between">
          {steps.map((step) => (
            <div
              key={step.step}
              className={`w-4 h-4 rounded-full ${
                step.step === currentStep ? 'bg-primary-500' : 'bg-gray-200'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
